import React from "react";
import styled from "styled-components";
import { Variant, variants } from "./types";
import { Image } from "../../../../components/Image";
import { RefreshIcon, WalletFilledIcon, WarningIcon } from "../../../../components/Svg";
import { Colors } from "../../../../theme/types";

const MenuIconWrapper = styled.div<{ borderColor: keyof Colors }>`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background};
  border-color: ${({ theme, borderColor }) => theme.colors[borderColor]};
  border-radius: 50%;
  border-style: solid;
  border-width: 2px;
  display: flex;
  height: 32px;
  justify-content: center;
  /* left: 0;
  position: absolute;
  top: 0; */
  width: 32px;
  z-index: 102;
`;

const ProfileIcon = styled(Image)`
  left: 0;
  position: absolute;
  top: 0;
  z-index: 102;

  & > img {
    border-radius: 50%;
  }
`;

export const NoProfileMenuIcon: React.FC<React.PropsWithChildren<{ className?: any }>> = ({
  className,
}: {
  className?: any;
}) => {
  const icons: Record<string, string> = {
    metaMask: `/newImages/wallet/metamask.png`,
    BybitWallet: `/newImages/wallet/bybit.png`,
    Bitkeep: `/newImages/wallet/bitget.png`,
    Okx: `/newImages/wallet/okx.png`,
    walletConnect: `/newImages/wallet/walletconnect.png`,
    Particle: `/newImages/wallet/particle.png`,
    bsc: `/newImages/wallet/bsc.svg`,
  };

  const wallet = ((localStorage.getItem("wagmi_v1.1.wallet") as string) || "").replaceAll("'", "").replaceAll('"', "");
  let icon = <WalletFilledIcon color="primary" width="24px" />;
  if (wallet && icons[wallet]) {
    icon = <img src={icons[wallet]} width="24px" height="24px" alt="icon" />;
  }
  return (
    <MenuIconWrapper borderColor="primary" className="menu-icon-wrapper">
      {icon}
    </MenuIconWrapper>
  );
};

export const PendingMenuIcon: React.FC<React.PropsWithChildren> = () => (
  <MenuIconWrapper borderColor="secondary">
    <RefreshIcon color="secondary" width="24px" spin />
  </MenuIconWrapper>
);

export const WarningMenuIcon: React.FC<React.PropsWithChildren> = () => (
  <MenuIconWrapper borderColor="warning">
    <WarningIcon color="warning" width="24px" />
  </MenuIconWrapper>
);

export const DangerMenuIcon: React.FC<React.PropsWithChildren> = () => (
  <MenuIconWrapper borderColor="failure">
    <WarningIcon color="failure" width="24px" />
  </MenuIconWrapper>
);

const MenuIcon: React.FC<React.PropsWithChildren<{ avatarSrc?: string; variant: Variant; className?: string }>> = ({
  avatarSrc,
  variant,
  className,
}) => {
  if (variant === variants.DANGER) {
    return <DangerMenuIcon />;
  }

  if (variant === variants.WARNING) {
    return <WarningMenuIcon />;
  }

  if (variant === variants.PENDING) {
    return <PendingMenuIcon />;
  }

  if (!avatarSrc) {
    return <NoProfileMenuIcon className={className} />;
  }

  return <ProfileIcon src={avatarSrc} height={32} width={32} className={className} />;
};

export default MenuIcon;
